import { render, staticRenderFns } from "./pre_file.vue?vue&type=template&id=44a1b2c5"
import script from "./pre_file.vue?vue&type=script&lang=js"
export * from "./pre_file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports